// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/chart.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AlertTrigger, Chart as Chart$1, ChartLinkKind, FilterKind, GroupByKind, MetricConfig, MetricConfigSeries, MetricFormula, MetricFormulaKind, MetricKind, RawMetricValueKind, StatisticVisualizationOptions, TimeSeriesVisualizationOptions, WindowFunctionKind } from "../../artifacts/v1/chart_pb";
import { file_chalk_artifacts_v1_chart } from "../../artifacts/v1/chart_pb";
import { file_chalk_auth_v1_permissions } from "../../auth/v1/permissions_pb";
import type { DenseTimeSeriesChart } from "../../chart/v1/densetimeserieschart_pb";
import { file_chalk_chart_v1_densetimeserieschart } from "../../chart/v1/densetimeserieschart_pb";
import type { MetricIncident } from "./incident_pb";
import { file_chalk_server_v1_incident } from "./incident_pb";
import type { Duration, FieldMask, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_duration, file_google_protobuf_field_mask, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/server/v1/chart.proto.
 */
export const file_chalk_server_v1_chart: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_artifacts_v1_chart, file_chalk_auth_v1_permissions, file_chalk_chart_v1_densetimeserieschart, file_chalk_server_v1_incident, file_google_protobuf_duration, file_google_protobuf_field_mask, file_google_protobuf_timestamp]);

/**
 * One dimension a series is grouped by, and the series' value for it.
 *
 * @generated from message chalk.server.v1.SeriesGroupValue
 */
export type SeriesGroupValue = Message<"chalk.server.v1.SeriesGroupValue"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: string value = 2;
   */
  value: string;
};

/**
 * Describes the message chalk.server.v1.SeriesGroupValue.
 * Use `create(SeriesGroupValueSchema)` to create a new message.
 */
export const SeriesGroupValueSchema: GenMessage<SeriesGroupValue> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 0);

/**
 * @generated from message chalk.server.v1.Series
 */
export type Series = Message<"chalk.server.v1.Series"> & {
  /**
   * @generated from field: repeated double points = 1;
   */
  points: number[];

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: string units = 3;
   */
  units: string;

  /**
   * Outermost first; empty when the series is ungrouped.
   *
   * @generated from field: repeated chalk.server.v1.SeriesGroupValue group_values = 4;
   */
  groupValues: SeriesGroupValue[];
};

/**
 * Describes the message chalk.server.v1.Series.
 * Use `create(SeriesSchema)` to create a new message.
 */
export const SeriesSchema: GenMessage<Series> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 1);

/**
 * @generated from message chalk.server.v1.Chart
 */
export type Chart = Message<"chalk.server.v1.Chart"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: repeated chalk.server.v1.Series series = 2;
   */
  series: Series[];

  /**
   * @generated from field: repeated int64 x_timestamp_ms = 4;
   */
  xTimestampMs: bigint[];
};

/**
 * Describes the message chalk.server.v1.Chart.
 * Use `create(ChartSchema)` to create a new message.
 */
export const ChartSchema: GenMessage<Chart> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 2);

/**
 * @generated from message chalk.server.v1.Point
 * @deprecated
 */
export type Point = Message<"chalk.server.v1.Point"> & {
  /**
   * wrapped in a Point to allow for optional (empty space in time series)
   *
   * @generated from field: optional int64 value = 1;
   */
  value?: bigint;
};

/**
 * Describes the message chalk.server.v1.Point.
 * Use `create(PointSchema)` to create a new message.
 * @deprecated
 */
export const PointSchema: GenMessage<Point> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 3);

/**
 * @generated from message chalk.server.v1.TimeSeries
 * @deprecated
 */
export type TimeSeries = Message<"chalk.server.v1.TimeSeries"> & {
  /**
   * @generated from field: repeated chalk.server.v1.Point points = 1;
   */
  points: Point[];

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: string units = 3;
   */
  units: string;
};

/**
 * Describes the message chalk.server.v1.TimeSeries.
 * Use `create(TimeSeriesSchema)` to create a new message.
 * @deprecated
 */
export const TimeSeriesSchema: GenMessage<TimeSeries> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 4);

/**
 * @generated from message chalk.server.v1.TimeSeriesChart
 * @deprecated
 */
export type TimeSeriesChart = Message<"chalk.server.v1.TimeSeriesChart"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: repeated chalk.server.v1.TimeSeries series = 2;
   */
  series: TimeSeries[];

  /**
   * @generated from field: repeated google.protobuf.Timestamp x_series = 3;
   */
  xSeries: Timestamp[];

  /**
   * @generated from field: google.protobuf.Duration window_period = 4;
   */
  windowPeriod?: Duration;
};

/**
 * Describes the message chalk.server.v1.TimeSeriesChart.
 * Use `create(TimeSeriesChartSchema)` to create a new message.
 * @deprecated
 */
export const TimeSeriesChartSchema: GenMessage<TimeSeriesChart> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 5);

/**
 * @generated from message chalk.server.v1.ChartAnnotation
 */
export type ChartAnnotation = Message<"chalk.server.v1.ChartAnnotation"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: optional string href = 3;
   */
  href?: string;

  /**
   * @generated from field: string label = 4;
   */
  label: string;

  /**
   * @generated from field: string color = 5;
   */
  color: string;

  /**
   * @generated from field: google.protobuf.Timestamp started_at = 6;
   */
  startedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp ended_at = 7;
   */
  endedAt?: Timestamp;
};

/**
 * Describes the message chalk.server.v1.ChartAnnotation.
 * Use `create(ChartAnnotationSchema)` to create a new message.
 */
export const ChartAnnotationSchema: GenMessage<ChartAnnotation> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 6);

/**
 * @generated from message chalk.server.v1.ListChartsFilters
 */
export type ListChartsFilters = Message<"chalk.server.v1.ListChartsFilters"> & {
  /**
   * @generated from field: optional chalk.artifacts.v1.ChartLinkKind link_entity_kind = 1;
   */
  linkEntityKind?: ChartLinkKind;

  /**
   * @generated from field: optional string linked_entity_id = 2;
   */
  linkedEntityId?: string;

  /**
   * Substring filter for linked_entity_id using case-sensitive contains matching.
   * Use this for search/filter UIs; use linked_entity_id for exact entity lookups.
   *
   * @generated from field: optional string linked_entity_id_search = 3;
   */
  linkedEntityIdSearch?: string;
};

/**
 * Describes the message chalk.server.v1.ListChartsFilters.
 * Use `create(ListChartsFiltersSchema)` to create a new message.
 */
export const ListChartsFiltersSchema: GenMessage<ListChartsFilters> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 7);

/**
 * @generated from message chalk.server.v1.ListChartPageToken
 */
export type ListChartPageToken = Message<"chalk.server.v1.ListChartPageToken"> & {
  /**
   * Charts are sorted first by creation time, descending
   *
   * @generated from field: google.protobuf.Timestamp created_at_hwm = 1;
   */
  createdAtHwm?: Timestamp;

  /**
   * Then by id, descending.
   * Note: this is the chart link id, not the metric config id hwm!
   *
   * @generated from field: string id_hwm = 2;
   */
  idHwm: string;
};

/**
 * Describes the message chalk.server.v1.ListChartPageToken.
 * Use `create(ListChartPageTokenSchema)` to create a new message.
 */
export const ListChartPageTokenSchema: GenMessage<ListChartPageToken> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 8);

/**
 * @generated from message chalk.server.v1.ListChartsRequest
 */
export type ListChartsRequest = Message<"chalk.server.v1.ListChartsRequest"> & {
  /**
   * @generated from field: optional chalk.server.v1.ListChartsFilters filters = 1;
   */
  filters?: ListChartsFilters;

  /**
   * @generated from field: optional int32 limit = 2;
   */
  limit?: number;

  /**
   * Must be encoded ListChartPageToken
   * see https://protobuf.dev/best-practices/api/#define-pagination-api
   *
   * @generated from field: optional string page_token = 3;
   */
  pageToken?: string;
};

/**
 * Describes the message chalk.server.v1.ListChartsRequest.
 * Use `create(ListChartsRequestSchema)` to create a new message.
 */
export const ListChartsRequestSchema: GenMessage<ListChartsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 9);

/**
 * @generated from message chalk.server.v1.ListChartsResponse
 */
export type ListChartsResponse = Message<"chalk.server.v1.ListChartsResponse"> & {
  /**
   * While still supported, heavily suggest using the second option charts_with_link
   * which includes metadata about other related entities to the chart
   *
   * @generated from field: repeated chalk.artifacts.v1.MetricConfig charts = 1 [deprecated = true];
   * @deprecated
   */
  charts: MetricConfig[];

  /**
   * @generated from field: repeated chalk.artifacts.v1.Chart charts_with_links = 2;
   */
  chartsWithLinks: Chart$1[];

  /**
   * encoded ListChartPageToken
   * see https://protobuf.dev/best-practices/api/#define-pagination-api
   *
   * @generated from field: optional string next_page_token = 3;
   */
  nextPageToken?: string;
};

/**
 * Describes the message chalk.server.v1.ListChartsResponse.
 * Use `create(ListChartsResponseSchema)` to create a new message.
 */
export const ListChartsResponseSchema: GenMessage<ListChartsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 10);

/**
 * @generated from message chalk.server.v1.CreateChartAnnotationRequest
 */
export type CreateChartAnnotationRequest = Message<"chalk.server.v1.CreateChartAnnotationRequest"> & {
  /**
   * @generated from field: chalk.server.v1.ChartAnnotation annotation = 1;
   */
  annotation?: ChartAnnotation;
};

/**
 * Describes the message chalk.server.v1.CreateChartAnnotationRequest.
 * Use `create(CreateChartAnnotationRequestSchema)` to create a new message.
 */
export const CreateChartAnnotationRequestSchema: GenMessage<CreateChartAnnotationRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 11);

/**
 * @generated from message chalk.server.v1.CreateChartAnnotationResponse
 */
export type CreateChartAnnotationResponse = Message<"chalk.server.v1.CreateChartAnnotationResponse"> & {
  /**
   * @generated from field: chalk.server.v1.ChartAnnotation annotation = 1;
   */
  annotation?: ChartAnnotation;
};

/**
 * Describes the message chalk.server.v1.CreateChartAnnotationResponse.
 * Use `create(CreateChartAnnotationResponseSchema)` to create a new message.
 */
export const CreateChartAnnotationResponseSchema: GenMessage<CreateChartAnnotationResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 12);

/**
 * @generated from message chalk.server.v1.ListChartAnnotationsRequest
 */
export type ListChartAnnotationsRequest = Message<"chalk.server.v1.ListChartAnnotationsRequest"> & {
  /**
   * @generated from field: string cursor = 1;
   */
  cursor: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * Describes the message chalk.server.v1.ListChartAnnotationsRequest.
 * Use `create(ListChartAnnotationsRequestSchema)` to create a new message.
 */
export const ListChartAnnotationsRequestSchema: GenMessage<ListChartAnnotationsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 13);

/**
 * @generated from message chalk.server.v1.ListChartAnnotationsResponse
 */
export type ListChartAnnotationsResponse = Message<"chalk.server.v1.ListChartAnnotationsResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.ChartAnnotation annotations = 1;
   */
  annotations: ChartAnnotation[];

  /**
   * @generated from field: string next_cursor = 2;
   */
  nextCursor: string;
};

/**
 * Describes the message chalk.server.v1.ListChartAnnotationsResponse.
 * Use `create(ListChartAnnotationsResponseSchema)` to create a new message.
 */
export const ListChartAnnotationsResponseSchema: GenMessage<ListChartAnnotationsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 14);

/**
 * @generated from message chalk.server.v1.DeleteChartAnnotationRequest
 */
export type DeleteChartAnnotationRequest = Message<"chalk.server.v1.DeleteChartAnnotationRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message chalk.server.v1.DeleteChartAnnotationRequest.
 * Use `create(DeleteChartAnnotationRequestSchema)` to create a new message.
 */
export const DeleteChartAnnotationRequestSchema: GenMessage<DeleteChartAnnotationRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 15);

/**
 * @generated from message chalk.server.v1.DeleteChartAnnotationResponse
 */
export type DeleteChartAnnotationResponse = Message<"chalk.server.v1.DeleteChartAnnotationResponse"> & {
  /**
   * return the deleted annotation
   *
   * @generated from field: chalk.server.v1.ChartAnnotation annotation = 1;
   */
  annotation?: ChartAnnotation;
};

/**
 * Describes the message chalk.server.v1.DeleteChartAnnotationResponse.
 * Use `create(DeleteChartAnnotationResponseSchema)` to create a new message.
 */
export const DeleteChartAnnotationResponseSchema: GenMessage<DeleteChartAnnotationResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 16);

/**
 * @generated from message chalk.server.v1.ListChartsWithCronAlertsRequest
 */
export type ListChartsWithCronAlertsRequest = Message<"chalk.server.v1.ListChartsWithCronAlertsRequest"> & {
  /**
   * @generated from field: optional int32 limit = 1;
   */
  limit?: number;

  /**
   * Must be encoded ListChartPageToken
   * see https://protobuf.dev/best-practices/api/#define-pagination-api
   *
   * @generated from field: optional string page_token = 2;
   */
  pageToken?: string;
};

/**
 * Describes the message chalk.server.v1.ListChartsWithCronAlertsRequest.
 * Use `create(ListChartsWithCronAlertsRequestSchema)` to create a new message.
 */
export const ListChartsWithCronAlertsRequestSchema: GenMessage<ListChartsWithCronAlertsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 17);

/**
 * @generated from message chalk.server.v1.ListChartsWithCronAlertsResponse
 */
export type ListChartsWithCronAlertsResponse = Message<"chalk.server.v1.ListChartsWithCronAlertsResponse"> & {
  /**
   * @generated from field: repeated chalk.artifacts.v1.Chart charts = 1;
   */
  charts: Chart$1[];

  /**
   * encoded ListChartPageToken
   * see https://protobuf.dev/best-practices/api/#define-pagination-api
   *
   * @generated from field: optional string next_page_token = 2;
   */
  nextPageToken?: string;
};

/**
 * Describes the message chalk.server.v1.ListChartsWithCronAlertsResponse.
 * Use `create(ListChartsWithCronAlertsResponseSchema)` to create a new message.
 */
export const ListChartsWithCronAlertsResponseSchema: GenMessage<ListChartsWithCronAlertsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 18);

/**
 * The same as a artifacts.v1.MetricConfig, but without an id and fully optional
 * note that field mask is also used to fully determine what should be
 *
 * @generated from message chalk.server.v1.UpdateMetricConfigOperation
 */
export type UpdateMetricConfigOperation = Message<"chalk.server.v1.UpdateMetricConfigOperation"> & {
  /**
   * @generated from field: optional string name = 1;
   */
  name?: string;

  /**
   * @generated from field: optional string window_period = 2;
   */
  windowPeriod?: string;

  /**
   * @generated from field: repeated chalk.artifacts.v1.MetricConfigSeries series = 3;
   */
  series: MetricConfigSeries[];

  /**
   * @generated from field: repeated chalk.artifacts.v1.MetricFormula formulas = 4;
   */
  formulas: MetricFormula[];

  /**
   * @generated from field: optional chalk.artifacts.v1.AlertTrigger trigger = 5;
   */
  trigger?: AlertTrigger;

  /**
   * @generated from field: optional bool graph_generated = 6;
   */
  graphGenerated?: boolean;

  /**
   * @generated from field: optional string display_window_period = 7;
   */
  displayWindowPeriod?: string;
};

/**
 * Describes the message chalk.server.v1.UpdateMetricConfigOperation.
 * Use `create(UpdateMetricConfigOperationSchema)` to create a new message.
 */
export const UpdateMetricConfigOperationSchema: GenMessage<UpdateMetricConfigOperation> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 19);

/**
 * @generated from message chalk.server.v1.CreateChartRequest
 */
export type CreateChartRequest = Message<"chalk.server.v1.CreateChartRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string window_period = 2;
   */
  windowPeriod: string;

  /**
   * @generated from field: repeated chalk.artifacts.v1.MetricConfigSeries series = 3;
   */
  series: MetricConfigSeries[];

  /**
   * @generated from field: repeated chalk.artifacts.v1.MetricFormula formulas = 4;
   */
  formulas: MetricFormula[];

  /**
   * @generated from field: chalk.artifacts.v1.AlertTrigger trigger = 5;
   */
  trigger?: AlertTrigger;

  /**
   * non-optional - must be linked
   *
   * @generated from field: chalk.artifacts.v1.ChartLinkKind link_entity_kind = 6;
   */
  linkEntityKind: ChartLinkKind;

  /**
   * optional since not all linked entities have an id (manual)
   *
   * @generated from field: optional string linked_entity_id = 7;
   */
  linkedEntityId?: string;

  /**
   * @generated from field: bool graph_generated = 8;
   */
  graphGenerated: boolean;

  /**
   * @generated from field: optional string display_window_period = 9;
   */
  displayWindowPeriod?: string;

  /**
   * @generated from field: repeated string mql_formulas = 10;
   */
  mqlFormulas: string[];

  /**
   * Which visualization this config renders as; unset is treated as a time series.
   *
   * @generated from oneof chalk.server.v1.CreateChartRequest.visualization_options
   */
  visualizationOptions: {
    /**
     * @generated from field: chalk.artifacts.v1.TimeSeriesVisualizationOptions time_series_options = 11;
     */
    value: TimeSeriesVisualizationOptions;
    case: "timeSeriesOptions";
  } | {
    /**
     * @generated from field: chalk.artifacts.v1.StatisticVisualizationOptions stat_options = 12;
     */
    value: StatisticVisualizationOptions;
    case: "statOptions";
  } | { case: undefined; value?: undefined };

  /**
   * Virtual chart this save replaces, so an edited default is written over it, not beside it.
   *
   * @generated from field: optional string virtual_chart_id = 13;
   */
  virtualChartId?: string;
};

/**
 * Describes the message chalk.server.v1.CreateChartRequest.
 * Use `create(CreateChartRequestSchema)` to create a new message.
 */
export const CreateChartRequestSchema: GenMessage<CreateChartRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 20);

/**
 * @generated from message chalk.server.v1.CreateChartResponse
 */
export type CreateChartResponse = Message<"chalk.server.v1.CreateChartResponse"> & {
  /**
   * @generated from field: optional chalk.artifacts.v1.Chart chart = 2;
   */
  chart?: Chart$1;
};

/**
 * Describes the message chalk.server.v1.CreateChartResponse.
 * Use `create(CreateChartResponseSchema)` to create a new message.
 */
export const CreateChartResponseSchema: GenMessage<CreateChartResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 21);

/**
 * @generated from message chalk.server.v1.UpdateMetricConfigRequest
 */
export type UpdateMetricConfigRequest = Message<"chalk.server.v1.UpdateMetricConfigRequest"> & {
  /**
   * @generated from field: string metric_config_id = 1;
   */
  metricConfigId: string;

  /**
   * @generated from field: chalk.server.v1.UpdateMetricConfigOperation update = 2;
   */
  update?: UpdateMetricConfigOperation;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 3;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message chalk.server.v1.UpdateMetricConfigRequest.
 * Use `create(UpdateMetricConfigRequestSchema)` to create a new message.
 */
export const UpdateMetricConfigRequestSchema: GenMessage<UpdateMetricConfigRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 22);

/**
 * @generated from message chalk.server.v1.UpdateMetricConfigResponse
 */
export type UpdateMetricConfigResponse = Message<"chalk.server.v1.UpdateMetricConfigResponse"> & {
  /**
   * @generated from field: chalk.artifacts.v1.MetricConfig metric_config = 1;
   */
  metricConfig?: MetricConfig;
};

/**
 * Describes the message chalk.server.v1.UpdateMetricConfigResponse.
 * Use `create(UpdateMetricConfigResponseSchema)` to create a new message.
 */
export const UpdateMetricConfigResponseSchema: GenMessage<UpdateMetricConfigResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 23);

/**
 * @generated from message chalk.server.v1.DecompileMetricConfigRequest
 */
export type DecompileMetricConfigRequest = Message<"chalk.server.v1.DecompileMetricConfigRequest"> & {
  /**
   * @generated from field: chalk.artifacts.v1.MetricConfig metric_config = 1;
   */
  metricConfig?: MetricConfig;

  /**
   * The selected chart output.
   *
   * @generated from field: chalk.server.v1.SelectedOutput selected_output = 2;
   */
  selectedOutput: SelectedOutput;

  /**
   * Zero-based index into series, or into mql_formulas when present and formulas otherwise.
   *
   * @generated from field: int32 metric_context_index = 3;
   */
  metricContextIndex: number;
};

/**
 * Describes the message chalk.server.v1.DecompileMetricConfigRequest.
 * Use `create(DecompileMetricConfigRequestSchema)` to create a new message.
 */
export const DecompileMetricConfigRequestSchema: GenMessage<DecompileMetricConfigRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 24);

/**
 * @generated from message chalk.server.v1.DecompileMetricConfigResponse
 */
export type DecompileMetricConfigResponse = Message<"chalk.server.v1.DecompileMetricConfigResponse"> & {
  /**
   * Series inputs for the monitor. Formula targets preserve the original series order.
   *
   * @generated from field: repeated string mql_series = 1;
   */
  mqlSeries: string[];

  /**
   * Present only when the selected output is a formula.
   *
   * @generated from field: optional string mql_formula = 2;
   */
  mqlFormula?: string;
};

/**
 * Describes the message chalk.server.v1.DecompileMetricConfigResponse.
 * Use `create(DecompileMetricConfigResponseSchema)` to create a new message.
 */
export const DecompileMetricConfigResponseSchema: GenMessage<DecompileMetricConfigResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 25);

/**
 * @generated from message chalk.server.v1.GetChartSnapshotRequest
 */
export type GetChartSnapshotRequest = Message<"chalk.server.v1.GetChartSnapshotRequest"> & {
  /**
   * @generated from field: chalk.artifacts.v1.MetricConfig metric_config = 1;
   */
  metricConfig?: MetricConfig;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 2;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 3;
   */
  endTime?: Timestamp;

  /**
   * @generated from field: optional bool use_start_as_origin = 4;
   */
  useStartAsOrigin?: boolean;

  /**
   * @generated from field: optional bool use_sketch_metrics_table = 5;
   */
  useSketchMetricsTable?: boolean;

  /**
   * @generated from field: optional bool return_sql_query_string = 6;
   */
  returnSqlQueryString?: boolean;

  /**
   * note: this defaults to true in the current implementation, but
   * when the UI has better affordances, we should have this be false
   *
   * @generated from field: optional bool exclude_incomplete_last_bucket = 7;
   */
  excludeIncompleteLastBucket?: boolean;

  /**
   * Optional per-request override of the metrics query backend. Overrides the
   * environment's configured default; mainly for A/B comparison and tests.
   *
   * @generated from field: optional chalk.server.v1.ChartMetricsBackend metrics_backend = 8;
   */
  metricsBackend?: ChartMetricsBackend;

  /**
   * Statistic tiles only: when set, also evaluate the window shifted back by this offset and return
   * its value as previous_value. (end-start) compares against the immediately preceding window; a
   * week/month against the same window one week/month ago.
   *
   * @generated from field: optional google.protobuf.Duration comparison_lookback_offset = 9;
   */
  comparisonLookbackOffset?: Duration;

  /**
   * Overrides the environment cluster for resource-scoped views.
   *
   * @generated from field: optional string cluster_id = 10;
   */
  clusterId?: string;
};

/**
 * Describes the message chalk.server.v1.GetChartSnapshotRequest.
 * Use `create(GetChartSnapshotRequestSchema)` to create a new message.
 */
export const GetChartSnapshotRequestSchema: GenMessage<GetChartSnapshotRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 26);

/**
 * @generated from message chalk.server.v1.GetChartSnapshotResponse
 */
export type GetChartSnapshotResponse = Message<"chalk.server.v1.GetChartSnapshotResponse"> & {
  /**
   * @generated from field: repeated chalk.chart.v1.DenseTimeSeriesChart charts = 1;
   */
  charts: DenseTimeSeriesChart[];

  /**
   * @generated from field: repeated google.protobuf.Timestamp x_series = 2;
   */
  xSeries: Timestamp[];

  /**
   * Bucket size actually used to render this chart, after backend safety clamping.
   * This is the display resolution; the alert lookback is not returned here.
   *
   * @generated from field: google.protobuf.Duration window_period = 3;
   */
  windowPeriod?: Duration;

  /**
   * @generated from field: repeated string sql_query_strings = 4;
   */
  sqlQueryStrings: string[];

  /**
   * Metrics backend that actually rendered this response, after any fallback.
   *
   * @generated from field: optional chalk.server.v1.ChartMetricsBackend metrics_backend = 5;
   */
  metricsBackend?: ChartMetricsBackend;

  /**
   * The series collapsed to one scalar for a statistic tile; set when metric_config carries
   * stat_options, unset for a plain time-series chart.
   *
   * @generated from field: optional chalk.server.v1.StatisticResult statistic = 6;
   */
  statistic?: StatisticResult;
};

/**
 * Describes the message chalk.server.v1.GetChartSnapshotResponse.
 * Use `create(GetChartSnapshotResponseSchema)` to create a new message.
 */
export const GetChartSnapshotResponseSchema: GenMessage<GetChartSnapshotResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 27);

/**
 * @generated from message chalk.server.v1.ClusterMetricConfigSeries
 */
export type ClusterMetricConfigSeries = Message<"chalk.server.v1.ClusterMetricConfigSeries"> & {
  /**
   * The server admits only the explicitly registered cluster-readable subset.
   *
   * @generated from field: chalk.artifacts.v1.MetricKind metric = 1;
   */
  metric: MetricKind;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;
};

/**
 * Describes the message chalk.server.v1.ClusterMetricConfigSeries.
 * Use `create(ClusterMetricConfigSeriesSchema)` to create a new message.
 */
export const ClusterMetricConfigSeriesSchema: GenMessage<ClusterMetricConfigSeries> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 28);

/**
 * @generated from message chalk.server.v1.ClusterMetricConfig
 */
export type ClusterMetricConfig = Message<"chalk.server.v1.ClusterMetricConfig"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: repeated chalk.server.v1.ClusterMetricConfigSeries series = 2;
   */
  series: ClusterMetricConfigSeries[];
};

/**
 * Describes the message chalk.server.v1.ClusterMetricConfig.
 * Use `create(ClusterMetricConfigSchema)` to create a new message.
 */
export const ClusterMetricConfigSchema: GenMessage<ClusterMetricConfig> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 29);

/**
 * @generated from message chalk.server.v1.GetClusterChartSnapshotRequest
 */
export type GetClusterChartSnapshotRequest = Message<"chalk.server.v1.GetClusterChartSnapshotRequest"> & {
  /**
   * @generated from field: string cluster_id = 1;
   */
  clusterId: string;

  /**
   * @generated from field: chalk.server.v1.ClusterMetricConfig metric_config = 2;
   */
  metricConfig?: ClusterMetricConfig;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 3;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 4;
   */
  endTime?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Duration step = 5;
   */
  step?: Duration;

  /**
   * @generated from field: optional bool exclude_incomplete_last_bucket = 6;
   */
  excludeIncompleteLastBucket?: boolean;
};

/**
 * Describes the message chalk.server.v1.GetClusterChartSnapshotRequest.
 * Use `create(GetClusterChartSnapshotRequestSchema)` to create a new message.
 */
export const GetClusterChartSnapshotRequestSchema: GenMessage<GetClusterChartSnapshotRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 30);

/**
 * @generated from message chalk.server.v1.GetClusterChartSnapshotResponse
 */
export type GetClusterChartSnapshotResponse = Message<"chalk.server.v1.GetClusterChartSnapshotResponse"> & {
  /**
   * @generated from field: repeated chalk.chart.v1.DenseTimeSeriesChart charts = 1;
   */
  charts: DenseTimeSeriesChart[];

  /**
   * @generated from field: repeated google.protobuf.Timestamp x_series = 2;
   */
  xSeries: Timestamp[];

  /**
   * @generated from field: google.protobuf.Duration window_period = 3;
   */
  windowPeriod?: Duration;

  /**
   * @generated from field: optional chalk.server.v1.ChartMetricsBackend metrics_backend = 4;
   */
  metricsBackend?: ChartMetricsBackend;
};

/**
 * Describes the message chalk.server.v1.GetClusterChartSnapshotResponse.
 * Use `create(GetClusterChartSnapshotResponseSchema)` to create a new message.
 */
export const GetClusterChartSnapshotResponseSchema: GenMessage<GetClusterChartSnapshotResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 31);

/**
 * @generated from message chalk.server.v1.GetChartSnapshotByQueryRequest
 */
export type GetChartSnapshotByQueryRequest = Message<"chalk.server.v1.GetChartSnapshotByQueryRequest"> & {
  /**
   * @generated from field: string query = 1 [deprecated = true];
   * @deprecated
   */
  query: string;

  /**
   * @generated from field: repeated string mql_series = 9;
   */
  mqlSeries: string[];

  /**
   * @generated from field: repeated string mql_formulae = 10;
   */
  mqlFormulae: string[];

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 2;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 3;
   */
  endTime?: Timestamp;

  /**
   * @generated from field: optional bool use_start_as_origin = 4;
   */
  useStartAsOrigin?: boolean;

  /**
   * @generated from field: optional bool use_sketch_metrics_table = 5;
   */
  useSketchMetricsTable?: boolean;

  /**
   * @generated from field: optional bool return_sql_query_string = 6;
   */
  returnSqlQueryString?: boolean;

  /**
   * @generated from field: optional bool exclude_incomplete_last_bucket = 7;
   */
  excludeIncompleteLastBucket?: boolean;

  /**
   * Optional per-request override of the metrics query backend (see
   * GetChartSnapshotRequest.metrics_backend).
   *
   * @generated from field: optional chalk.server.v1.ChartMetricsBackend metrics_backend = 8;
   */
  metricsBackend?: ChartMetricsBackend;
};

/**
 * Describes the message chalk.server.v1.GetChartSnapshotByQueryRequest.
 * Use `create(GetChartSnapshotByQueryRequestSchema)` to create a new message.
 */
export const GetChartSnapshotByQueryRequestSchema: GenMessage<GetChartSnapshotByQueryRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 32);

/**
 * @generated from message chalk.server.v1.GetChartSnapshotByQueryResponse
 */
export type GetChartSnapshotByQueryResponse = Message<"chalk.server.v1.GetChartSnapshotByQueryResponse"> & {
  /**
   * @generated from field: repeated chalk.chart.v1.DenseTimeSeriesChart charts = 1;
   */
  charts: DenseTimeSeriesChart[];

  /**
   * @generated from field: repeated google.protobuf.Timestamp x_series = 2;
   */
  xSeries: Timestamp[];

  /**
   * Bucket size actually used to render this chart, after backend safety clamping.
   * This is the display resolution; the alert lookback is not returned here.
   *
   * @generated from field: google.protobuf.Duration window_period = 3;
   */
  windowPeriod?: Duration;

  /**
   * @generated from field: repeated string sql_query_strings = 4;
   */
  sqlQueryStrings: string[];

  /**
   * @generated from field: chalk.artifacts.v1.MetricConfig compiled_metric_config = 5;
   */
  compiledMetricConfig?: MetricConfig;
};

/**
 * Describes the message chalk.server.v1.GetChartSnapshotByQueryResponse.
 * Use `create(GetChartSnapshotByQueryResponseSchema)` to create a new message.
 */
export const GetChartSnapshotByQueryResponseSchema: GenMessage<GetChartSnapshotByQueryResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 33);

/**
 * One scalar evaluated from a metric or log query over a range, for a statistic tile. Returned by
 * ChartsService.GetChartSnapshot (when metric_config carries stat_options) and
 * LogSearchService.GetLogStat.
 *
 * @generated from message chalk.server.v1.StatisticResult
 */
export type StatisticResult = Message<"chalk.server.v1.StatisticResult"> & {
  /**
   * Unset when the backend has no value to show (e.g. it cannot compute this stat over the range).
   *
   * @generated from field: optional double value = 1;
   */
  value?: number;

  /**
   * Unit inferred by the backend (e.g. "count", "ms"); empty when unknown. The tile may override it.
   *
   * @generated from field: string unit = 2;
   */
  unit: string;

  /**
   * Set only when comparison_lookback_offset was requested; the tile derives the percentage change
   * from value and previous_value itself.
   *
   * @generated from field: optional double previous_value = 3;
   */
  previousValue?: number;

  /**
   * Set whenever previous_value is; labels what it compares against (e.g. "vs. previous 24h").
   *
   * @generated from field: optional google.protobuf.Duration comparison_lookback_offset = 4;
   */
  comparisonLookbackOffset?: Duration;

  /**
   * Span the value actually covers, when narrower than the request because partial buckets dropped.
   *
   * @generated from field: optional google.protobuf.Duration evaluated_window = 5;
   */
  evaluatedWindow?: Duration;
};

/**
 * Describes the message chalk.server.v1.StatisticResult.
 * Use `create(StatisticResultSchema)` to create a new message.
 */
export const StatisticResultSchema: GenMessage<StatisticResult> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 34);

/**
 * @generated from message chalk.server.v1.DeleteChartRequest
 */
export type DeleteChartRequest = Message<"chalk.server.v1.DeleteChartRequest"> & {
  /**
   * @generated from field: string metric_config_id = 1;
   */
  metricConfigId: string;
};

/**
 * Describes the message chalk.server.v1.DeleteChartRequest.
 * Use `create(DeleteChartRequestSchema)` to create a new message.
 */
export const DeleteChartRequestSchema: GenMessage<DeleteChartRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 35);

/**
 * @generated from message chalk.server.v1.DeleteChartResponse
 */
export type DeleteChartResponse = Message<"chalk.server.v1.DeleteChartResponse"> & {
};

/**
 * Describes the message chalk.server.v1.DeleteChartResponse.
 * Use `create(DeleteChartResponseSchema)` to create a new message.
 */
export const DeleteChartResponseSchema: GenMessage<DeleteChartResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 36);

/**
 * @generated from message chalk.server.v1.GetChartRequest
 */
export type GetChartRequest = Message<"chalk.server.v1.GetChartRequest"> & {
  /**
   * @generated from field: string chart_id = 1;
   */
  chartId: string;
};

/**
 * Describes the message chalk.server.v1.GetChartRequest.
 * Use `create(GetChartRequestSchema)` to create a new message.
 */
export const GetChartRequestSchema: GenMessage<GetChartRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 37);

/**
 * @generated from message chalk.server.v1.GetChartResponse
 */
export type GetChartResponse = Message<"chalk.server.v1.GetChartResponse"> & {
  /**
   * @generated from field: chalk.artifacts.v1.Chart chart = 1;
   */
  chart?: Chart$1;

  /**
   * @generated from field: repeated chalk.server.v1.MetricIncident active_incidents = 2;
   */
  activeIncidents: MetricIncident[];
};

/**
 * Describes the message chalk.server.v1.GetChartResponse.
 * Use `create(GetChartResponseSchema)` to create a new message.
 */
export const GetChartResponseSchema: GenMessage<GetChartResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 38);

/**
 * @generated from message chalk.server.v1.GetChartOptionsRequest
 */
export type GetChartOptionsRequest = Message<"chalk.server.v1.GetChartOptionsRequest"> & {
};

/**
 * Describes the message chalk.server.v1.GetChartOptionsRequest.
 * Use `create(GetChartOptionsRequestSchema)` to create a new message.
 */
export const GetChartOptionsRequestSchema: GenMessage<GetChartOptionsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 39);

/**
 * @generated from message chalk.server.v1.FilterOptionNamespace
 */
export type FilterOptionNamespace = Message<"chalk.server.v1.FilterOptionNamespace"> & {
  /**
   * @generated from field: string namespace = 1;
   */
  namespace: string;

  /**
   * @generated from field: repeated string values = 2;
   */
  values: string[];
};

/**
 * Describes the message chalk.server.v1.FilterOptionNamespace.
 * Use `create(FilterOptionNamespaceSchema)` to create a new message.
 */
export const FilterOptionNamespaceSchema: GenMessage<FilterOptionNamespace> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 40);

/**
 * @generated from message chalk.server.v1.FilterOption
 */
export type FilterOption = Message<"chalk.server.v1.FilterOption"> & {
  /**
   * @generated from field: string display_name = 1;
   */
  displayName: string;

  /**
   * @generated from field: chalk.artifacts.v1.FilterKind kind = 2;
   */
  kind: FilterKind;

  /**
   * @generated from field: repeated chalk.server.v1.FilterOptionNamespace namespaced_values = 3;
   */
  namespacedValues: FilterOptionNamespace[];
};

/**
 * Describes the message chalk.server.v1.FilterOption.
 * Use `create(FilterOptionSchema)` to create a new message.
 */
export const FilterOptionSchema: GenMessage<FilterOption> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 41);

/**
 * @generated from message chalk.server.v1.GroupOption
 */
export type GroupOption = Message<"chalk.server.v1.GroupOption"> & {
  /**
   * @generated from field: string display_name = 1;
   */
  displayName: string;

  /**
   * @generated from field: chalk.artifacts.v1.GroupByKind kind = 2;
   */
  kind: GroupByKind;
};

/**
 * Describes the message chalk.server.v1.GroupOption.
 * Use `create(GroupOptionSchema)` to create a new message.
 */
export const GroupOptionSchema: GenMessage<GroupOption> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 42);

/**
 * @generated from message chalk.server.v1.WindowFunctionOption
 */
export type WindowFunctionOption = Message<"chalk.server.v1.WindowFunctionOption"> & {
  /**
   * @generated from field: string display_name = 1;
   */
  displayName: string;

  /**
   * @generated from field: chalk.artifacts.v1.WindowFunctionKind window_function = 2;
   */
  windowFunction: WindowFunctionKind;
};

/**
 * Describes the message chalk.server.v1.WindowFunctionOption.
 * Use `create(WindowFunctionOptionSchema)` to create a new message.
 */
export const WindowFunctionOptionSchema: GenMessage<WindowFunctionOption> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 43);

/**
 * @generated from message chalk.server.v1.MetricOptions
 */
export type MetricOptions = Message<"chalk.server.v1.MetricOptions"> & {
  /**
   * @generated from field: chalk.artifacts.v1.MetricKind kind = 1;
   */
  kind: MetricKind;

  /**
   * @generated from field: repeated chalk.server.v1.FilterOption filters = 2;
   */
  filters: FilterOption[];

  /**
   * @generated from field: repeated chalk.server.v1.GroupOption groups = 3;
   */
  groups: GroupOption[];

  /**
   * @generated from field: repeated chalk.server.v1.WindowFunctionOption window_functions = 4;
   */
  windowFunctions: WindowFunctionOption[];

  /**
   * Display grouping for the metric-kind dropdown. The client buckets options by this and
   * orders the groups by the enum's value.
   *
   * @generated from field: chalk.server.v1.MetricKindGroup metric_kind_group = 5;
   */
  metricKindGroup: MetricKindGroup;
};

/**
 * Describes the message chalk.server.v1.MetricOptions.
 * Use `create(MetricOptionsSchema)` to create a new message.
 */
export const MetricOptionsSchema: GenMessage<MetricOptions> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 44);

/**
 * @generated from message chalk.server.v1.MetricFormulaFeatureOperandInput
 */
export type MetricFormulaFeatureOperandInput = Message<"chalk.server.v1.MetricFormulaFeatureOperandInput"> & {
  /**
   * @generated from field: string namespace = 1;
   */
  namespace: string;

  /**
   * @generated from field: repeated string feature_fqns = 2;
   */
  featureFqns: string[];
};

/**
 * Describes the message chalk.server.v1.MetricFormulaFeatureOperandInput.
 * Use `create(MetricFormulaFeatureOperandInputSchema)` to create a new message.
 */
export const MetricFormulaFeatureOperandInputSchema: GenMessage<MetricFormulaFeatureOperandInput> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 45);

/**
 * @generated from message chalk.server.v1.MetricFormulaFeatureOperandList
 */
export type MetricFormulaFeatureOperandList = Message<"chalk.server.v1.MetricFormulaFeatureOperandList"> & {
  /**
   * @generated from field: string namespace = 1 [deprecated = true];
   * @deprecated
   */
  namespace: string;

  /**
   * @generated from field: repeated string values = 2 [deprecated = true];
   * @deprecated
   */
  values: string[];

  /**
   * @generated from field: repeated chalk.server.v1.MetricFormulaFeatureOperandInput features = 3;
   */
  features: MetricFormulaFeatureOperandInput[];
};

/**
 * Describes the message chalk.server.v1.MetricFormulaFeatureOperandList.
 * Use `create(MetricFormulaFeatureOperandListSchema)` to create a new message.
 */
export const MetricFormulaFeatureOperandListSchema: GenMessage<MetricFormulaFeatureOperandList> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 46);

/**
 * @generated from message chalk.server.v1.MetricFormulaDatasetOperandInput
 */
export type MetricFormulaDatasetOperandInput = Message<"chalk.server.v1.MetricFormulaDatasetOperandInput"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: repeated string output_fqns = 3;
   */
  outputFqns: string[];
};

/**
 * Describes the message chalk.server.v1.MetricFormulaDatasetOperandInput.
 * Use `create(MetricFormulaDatasetOperandInputSchema)` to create a new message.
 */
export const MetricFormulaDatasetOperandInputSchema: GenMessage<MetricFormulaDatasetOperandInput> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 47);

/**
 * @generated from message chalk.server.v1.MetricFormulaDatasetOperandList
 */
export type MetricFormulaDatasetOperandList = Message<"chalk.server.v1.MetricFormulaDatasetOperandList"> & {
  /**
   * @generated from field: repeated string values = 1 [deprecated = true];
   * @deprecated
   */
  values: string[];

  /**
   * @generated from field: repeated chalk.server.v1.MetricFormulaDatasetOperandInput datasets = 2;
   */
  datasets: MetricFormulaDatasetOperandInput[];
};

/**
 * Describes the message chalk.server.v1.MetricFormulaDatasetOperandList.
 * Use `create(MetricFormulaDatasetOperandListSchema)` to create a new message.
 */
export const MetricFormulaDatasetOperandListSchema: GenMessage<MetricFormulaDatasetOperandList> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 48);

/**
 * @generated from message chalk.server.v1.MetricFormulaOperand
 */
export type MetricFormulaOperand = Message<"chalk.server.v1.MetricFormulaOperand"> & {
  /**
   * @generated from field: chalk.server.v1.MetricFormulaOperandKind kind = 1;
   */
  kind: MetricFormulaOperandKind;

  /**
   * @generated from oneof chalk.server.v1.MetricFormulaOperand.local_operand_inputs
   */
  localOperandInputs: {
    /**
     * @generated from field: chalk.server.v1.MetricFormulaDatasetOperandList dataset_operands = 2;
     */
    value: MetricFormulaDatasetOperandList;
    case: "datasetOperands";
  } | {
    /**
     * @generated from field: chalk.server.v1.MetricFormulaFeatureOperandList feature_operands = 3;
     */
    value: MetricFormulaFeatureOperandList;
    case: "featureOperands";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.server.v1.MetricFormulaOperand.
 * Use `create(MetricFormulaOperandSchema)` to create a new message.
 */
export const MetricFormulaOperandSchema: GenMessage<MetricFormulaOperand> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 49);

/**
 * @generated from message chalk.server.v1.MetricFormulaOption
 */
export type MetricFormulaOption = Message<"chalk.server.v1.MetricFormulaOption"> & {
  /**
   * @generated from field: string display_name = 1;
   */
  displayName: string;

  /**
   * @generated from field: chalk.artifacts.v1.MetricFormulaKind kind = 2;
   */
  kind: MetricFormulaKind;

  /**
   * @generated from field: repeated chalk.server.v1.MetricFormulaOperand operands = 3;
   */
  operands: MetricFormulaOperand[];
};

/**
 * Describes the message chalk.server.v1.MetricFormulaOption.
 * Use `create(MetricFormulaOptionSchema)` to create a new message.
 */
export const MetricFormulaOptionSchema: GenMessage<MetricFormulaOption> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 50);

/**
 * @generated from message chalk.server.v1.GetChartOptionsResponse
 */
export type GetChartOptionsResponse = Message<"chalk.server.v1.GetChartOptionsResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.MetricOptions metrics = 1;
   */
  metrics: MetricOptions[];

  /**
   * @generated from field: repeated chalk.server.v1.MetricFormulaOption formulas = 2;
   */
  formulas: MetricFormulaOption[];
};

/**
 * Describes the message chalk.server.v1.GetChartOptionsResponse.
 * Use `create(GetChartOptionsResponseSchema)` to create a new message.
 */
export const GetChartOptionsResponseSchema: GenMessage<GetChartOptionsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 51);

/**
 * @generated from message chalk.server.v1.MetricHealthCheck
 */
export type MetricHealthCheck = Message<"chalk.server.v1.MetricHealthCheck"> & {
  /**
   * @generated from field: chalk.server.v1.MetricHealthStatus status = 1;
   */
  status: MetricHealthStatus;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message chalk.server.v1.MetricHealthCheck.
 * Use `create(MetricHealthCheckSchema)` to create a new message.
 */
export const MetricHealthCheckSchema: GenMessage<MetricHealthCheck> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 52);

/**
 * @generated from message chalk.server.v1.SparkPoint
 */
export type SparkPoint = Message<"chalk.server.v1.SparkPoint"> & {
  /**
   * @generated from field: double x = 1;
   */
  x: number;

  /**
   * @generated from field: optional double y = 2;
   */
  y?: number;
};

/**
 * Describes the message chalk.server.v1.SparkPoint.
 * Use `create(SparkPointSchema)` to create a new message.
 */
export const SparkPointSchema: GenMessage<SparkPoint> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 53);

/**
 * @generated from message chalk.server.v1.SparkSeries
 */
export type SparkSeries = Message<"chalk.server.v1.SparkSeries"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: repeated chalk.server.v1.SparkPoint points = 2;
   */
  points: SparkPoint[];
};

/**
 * Describes the message chalk.server.v1.SparkSeries.
 * Use `create(SparkSeriesSchema)` to create a new message.
 */
export const SparkSeriesSchema: GenMessage<SparkSeries> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 54);

/**
 * @generated from message chalk.server.v1.EntityMetrics
 */
export type EntityMetrics = Message<"chalk.server.v1.EntityMetrics"> & {
  /**
   * @generated from field: string fqn = 1;
   */
  fqn: string;

  /**
   * @generated from field: optional chalk.server.v1.SparkSeries successful_requests = 2;
   */
  successfulRequests?: SparkSeries;

  /**
   * @generated from field: optional chalk.server.v1.SparkSeries failed_requests = 3;
   */
  failedRequests?: SparkSeries;

  /**
   * @generated from field: chalk.server.v1.MetricHealthCheck health = 4;
   */
  health?: MetricHealthCheck;
};

/**
 * Describes the message chalk.server.v1.EntityMetrics.
 * Use `create(EntityMetricsSchema)` to create a new message.
 */
export const EntityMetricsSchema: GenMessage<EntityMetrics> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 55);

/**
 * @generated from message chalk.server.v1.GetFeatureMetricsRequest
 */
export type GetFeatureMetricsRequest = Message<"chalk.server.v1.GetFeatureMetricsRequest"> & {
  /**
   * @generated from field: repeated string fqns = 1;
   */
  fqns: string[];
};

/**
 * Describes the message chalk.server.v1.GetFeatureMetricsRequest.
 * Use `create(GetFeatureMetricsRequestSchema)` to create a new message.
 */
export const GetFeatureMetricsRequestSchema: GenMessage<GetFeatureMetricsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 56);

/**
 * @generated from message chalk.server.v1.GetFeatureMetricsResponse
 */
export type GetFeatureMetricsResponse = Message<"chalk.server.v1.GetFeatureMetricsResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.EntityMetrics metrics = 1;
   */
  metrics: EntityMetrics[];
};

/**
 * Describes the message chalk.server.v1.GetFeatureMetricsResponse.
 * Use `create(GetFeatureMetricsResponseSchema)` to create a new message.
 */
export const GetFeatureMetricsResponseSchema: GenMessage<GetFeatureMetricsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 57);

/**
 * @generated from message chalk.server.v1.GetResolverMetricsRequest
 */
export type GetResolverMetricsRequest = Message<"chalk.server.v1.GetResolverMetricsRequest"> & {
  /**
   * @generated from field: repeated string fqns = 1;
   */
  fqns: string[];
};

/**
 * Describes the message chalk.server.v1.GetResolverMetricsRequest.
 * Use `create(GetResolverMetricsRequestSchema)` to create a new message.
 */
export const GetResolverMetricsRequestSchema: GenMessage<GetResolverMetricsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 58);

/**
 * @generated from message chalk.server.v1.GetResolverMetricsResponse
 */
export type GetResolverMetricsResponse = Message<"chalk.server.v1.GetResolverMetricsResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.EntityMetrics metrics = 1;
   */
  metrics: EntityMetrics[];
};

/**
 * Describes the message chalk.server.v1.GetResolverMetricsResponse.
 * Use `create(GetResolverMetricsResponseSchema)` to create a new message.
 */
export const GetResolverMetricsResponseSchema: GenMessage<GetResolverMetricsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 59);

/**
 * @generated from message chalk.server.v1.GetQueryMetricsRequest
 */
export type GetQueryMetricsRequest = Message<"chalk.server.v1.GetQueryMetricsRequest"> & {
  /**
   * @generated from field: repeated string fqns = 1;
   */
  fqns: string[];
};

/**
 * Describes the message chalk.server.v1.GetQueryMetricsRequest.
 * Use `create(GetQueryMetricsRequestSchema)` to create a new message.
 */
export const GetQueryMetricsRequestSchema: GenMessage<GetQueryMetricsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 60);

/**
 * @generated from message chalk.server.v1.GetQueryMetricsResponse
 */
export type GetQueryMetricsResponse = Message<"chalk.server.v1.GetQueryMetricsResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.EntityMetrics metrics = 1;
   */
  metrics: EntityMetrics[];
};

/**
 * Describes the message chalk.server.v1.GetQueryMetricsResponse.
 * Use `create(GetQueryMetricsResponseSchema)` to create a new message.
 */
export const GetQueryMetricsResponseSchema: GenMessage<GetQueryMetricsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 61);

/**
 * @generated from message chalk.server.v1.GetMetricOptionsRequest
 */
export type GetMetricOptionsRequest = Message<"chalk.server.v1.GetMetricOptionsRequest"> & {
  /**
   * @generated from field: chalk.artifacts.v1.MetricKind metric_kind = 1;
   */
  metricKind: MetricKind;
};

/**
 * Describes the message chalk.server.v1.GetMetricOptionsRequest.
 * Use `create(GetMetricOptionsRequestSchema)` to create a new message.
 */
export const GetMetricOptionsRequestSchema: GenMessage<GetMetricOptionsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 62);

/**
 * @generated from message chalk.server.v1.GetMetricOptionsResponse
 */
export type GetMetricOptionsResponse = Message<"chalk.server.v1.GetMetricOptionsResponse"> & {
  /**
   * @generated from field: chalk.server.v1.MetricOptions metric_options = 1;
   */
  metricOptions?: MetricOptions;
};

/**
 * Describes the message chalk.server.v1.GetMetricOptionsResponse.
 * Use `create(GetMetricOptionsResponseSchema)` to create a new message.
 */
export const GetMetricOptionsResponseSchema: GenMessage<GetMetricOptionsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 63);

/**
 * @generated from message chalk.server.v1.GetFormulaOptionsRequest
 */
export type GetFormulaOptionsRequest = Message<"chalk.server.v1.GetFormulaOptionsRequest"> & {
  /**
   * @generated from field: chalk.artifacts.v1.MetricFormulaKind formula_kind = 1;
   */
  formulaKind: MetricFormulaKind;
};

/**
 * Describes the message chalk.server.v1.GetFormulaOptionsRequest.
 * Use `create(GetFormulaOptionsRequestSchema)` to create a new message.
 */
export const GetFormulaOptionsRequestSchema: GenMessage<GetFormulaOptionsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 64);

/**
 * @generated from message chalk.server.v1.GetFormulaOptionsResponse
 */
export type GetFormulaOptionsResponse = Message<"chalk.server.v1.GetFormulaOptionsResponse"> & {
  /**
   * @generated from field: chalk.server.v1.MetricFormulaOption formula_options = 1;
   */
  formulaOptions?: MetricFormulaOption;
};

/**
 * Describes the message chalk.server.v1.GetFormulaOptionsResponse.
 * Use `create(GetFormulaOptionsResponseSchema)` to create a new message.
 */
export const GetFormulaOptionsResponseSchema: GenMessage<GetFormulaOptionsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 65);

/**
 * RawMetricDescriptor describes one series family available in the environment's
 * VictoriaMetrics instance. VictoriaMetrics does not store Prometheus metric
 * metadata, so `value_kind` and `unit` are inferred from the series name's
 * suffix rather than read from the store.
 *
 * @generated from message chalk.server.v1.RawMetricDescriptor
 */
export type RawMetricDescriptor = Message<"chalk.server.v1.RawMetricDescriptor"> & {
  /**
   * VictoriaMetrics series name, e.g. "chalk_query_plan_latency_bucket".
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: chalk.artifacts.v1.RawMetricValueKind value_kind = 2;
   */
  valueKind: RawMetricValueKind;

  /**
   * Label names observed on this series. Empty unless the request asked for
   * labels, since resolving them costs one VictoriaMetrics round-trip per metric.
   *
   * @generated from field: repeated string label_names = 3;
   */
  labelNames: string[];

  /**
   * Active series carrying this name, from VictoriaMetrics' TSDB status. Unset
   * when the name fell outside the TSDB status top-N.
   *
   * @generated from field: optional uint64 series_count = 4;
   */
  seriesCount?: bigint;

  /**
   * Unit inferred from the name suffix (e.g. "seconds", "bytes"). Unset when the
   * name carries no recognizable unit.
   *
   * @generated from field: optional string unit = 5;
   */
  unit?: string;

  /**
   * For histogram families, the name with the _bucket/_sum/_count suffix removed.
   *
   * @generated from field: optional string family_base_name = 6;
   */
  familyBaseName?: string;
};

/**
 * Describes the message chalk.server.v1.RawMetricDescriptor.
 * Use `create(RawMetricDescriptorSchema)` to create a new message.
 */
export const RawMetricDescriptorSchema: GenMessage<RawMetricDescriptor> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 66);

/**
 * @generated from message chalk.server.v1.ListRawMetricsRequest
 */
export type ListRawMetricsRequest = Message<"chalk.server.v1.ListRawMetricsRequest"> & {
  /**
   * Case-insensitive substring match on the series name. Unset returns everything.
   *
   * @generated from field: optional string name_filter = 1;
   */
  nameFilter?: string;

  /**
   * Maximum descriptors to return after filtering. Unset or <= 0 applies a server default.
   *
   * @generated from field: optional int32 limit = 2;
   */
  limit?: number;

  /**
   * Resolve label_names per returned metric. Off by default: it costs one
   * VictoriaMetrics round-trip per metric.
   *
   * @generated from field: bool include_label_names = 3;
   */
  includeLabelNames: boolean;
};

/**
 * Describes the message chalk.server.v1.ListRawMetricsRequest.
 * Use `create(ListRawMetricsRequestSchema)` to create a new message.
 */
export const ListRawMetricsRequestSchema: GenMessage<ListRawMetricsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 67);

/**
 * @generated from message chalk.server.v1.ListRawMetricsResponse
 */
export type ListRawMetricsResponse = Message<"chalk.server.v1.ListRawMetricsResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.RawMetricDescriptor metrics = 1;
   */
  metrics: RawMetricDescriptor[];

  /**
   * Metrics matching name_filter before `limit` truncation, so callers can tell a
   * truncated page from a complete one.
   *
   * @generated from field: int32 total_matching_count = 2;
   */
  totalMatchingCount: number;
};

/**
 * Describes the message chalk.server.v1.ListRawMetricsResponse.
 * Use `create(ListRawMetricsResponseSchema)` to create a new message.
 */
export const ListRawMetricsResponseSchema: GenMessage<ListRawMetricsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 68);

/**
 * @generated from message chalk.server.v1.GetRawMetricLabelNamesRequest
 */
export type GetRawMetricLabelNamesRequest = Message<"chalk.server.v1.GetRawMetricLabelNamesRequest"> & {
  /**
   * Exact VictoriaMetrics series name. Unlike ListRawMetricsRequest.name_filter this
   * is not a substring match, so the labels returned always belong to this series.
   *
   * @generated from field: string metric_name = 1;
   */
  metricName: string;
};

/**
 * Describes the message chalk.server.v1.GetRawMetricLabelNamesRequest.
 * Use `create(GetRawMetricLabelNamesRequestSchema)` to create a new message.
 */
export const GetRawMetricLabelNamesRequestSchema: GenMessage<GetRawMetricLabelNamesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 69);

/**
 * @generated from message chalk.server.v1.GetRawMetricLabelNamesResponse
 */
export type GetRawMetricLabelNamesResponse = Message<"chalk.server.v1.GetRawMetricLabelNamesResponse"> & {
  /**
   * Label names observed on the series, excluding the reserved `__name__`.
   *
   * @generated from field: repeated string label_names = 1;
   */
  labelNames: string[];
};

/**
 * Describes the message chalk.server.v1.GetRawMetricLabelNamesResponse.
 * Use `create(GetRawMetricLabelNamesResponseSchema)` to create a new message.
 */
export const GetRawMetricLabelNamesResponseSchema: GenMessage<GetRawMetricLabelNamesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 70);

/**
 * @generated from message chalk.server.v1.GetRawMetricLabelValuesRequest
 */
export type GetRawMetricLabelValuesRequest = Message<"chalk.server.v1.GetRawMetricLabelValuesRequest"> & {
  /**
   * Restrict values to those present on this series name. Unset returns the
   * label's values across every series in the environment's instance.
   *
   * @generated from field: optional string metric_name = 1;
   */
  metricName?: string;

  /**
   * @generated from field: string label_name = 2;
   */
  labelName: string;

  /**
   * @generated from field: optional int32 limit = 3;
   */
  limit?: number;
};

/**
 * Describes the message chalk.server.v1.GetRawMetricLabelValuesRequest.
 * Use `create(GetRawMetricLabelValuesRequestSchema)` to create a new message.
 */
export const GetRawMetricLabelValuesRequestSchema: GenMessage<GetRawMetricLabelValuesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 71);

/**
 * @generated from message chalk.server.v1.GetRawMetricLabelValuesResponse
 */
export type GetRawMetricLabelValuesResponse = Message<"chalk.server.v1.GetRawMetricLabelValuesResponse"> & {
  /**
   * @generated from field: repeated string values = 1;
   */
  values: string[];
};

/**
 * Describes the message chalk.server.v1.GetRawMetricLabelValuesResponse.
 * Use `create(GetRawMetricLabelValuesResponseSchema)` to create a new message.
 */
export const GetRawMetricLabelValuesResponseSchema: GenMessage<GetRawMetricLabelValuesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 72);

/**
 * @generated from message chalk.server.v1.RawMetricsQueryPoint
 */
export type RawMetricsQueryPoint = Message<"chalk.server.v1.RawMetricsQueryPoint"> & {
  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 1;
   */
  timestamp?: Timestamp;

  /**
   * @generated from field: double value = 2;
   */
  value: number;
};

/**
 * Describes the message chalk.server.v1.RawMetricsQueryPoint.
 * Use `create(RawMetricsQueryPointSchema)` to create a new message.
 */
export const RawMetricsQueryPointSchema: GenMessage<RawMetricsQueryPoint> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 73);

/**
 * @generated from message chalk.server.v1.RawMetricsQuerySeries
 */
export type RawMetricsQuerySeries = Message<"chalk.server.v1.RawMetricsQuerySeries"> & {
  /**
   * @generated from field: map<string, string> labels = 1;
   */
  labels: { [key: string]: string };

  /**
   * @generated from field: repeated chalk.server.v1.RawMetricsQueryPoint points = 2;
   */
  points: RawMetricsQueryPoint[];
};

/**
 * Describes the message chalk.server.v1.RawMetricsQuerySeries.
 * Use `create(RawMetricsQuerySeriesSchema)` to create a new message.
 */
export const RawMetricsQuerySeriesSchema: GenMessage<RawMetricsQuerySeries> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 74);

/**
 * @generated from message chalk.server.v1.QueryRawMetricsRequest
 */
export type QueryRawMetricsRequest = Message<"chalk.server.v1.QueryRawMetricsRequest"> & {
  /**
   * MetricsQL, evaluated verbatim as a range query. No environment scoping is
   * injected, so the query must scope itself.
   *
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 2;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 3;
   */
  endTime?: Timestamp;

  /**
   * Range-query step. Unset or <= 0 applies a server default derived from the range.
   *
   * @generated from field: optional google.protobuf.Duration step = 4;
   */
  step?: Duration;
};

/**
 * Describes the message chalk.server.v1.QueryRawMetricsRequest.
 * Use `create(QueryRawMetricsRequestSchema)` to create a new message.
 */
export const QueryRawMetricsRequestSchema: GenMessage<QueryRawMetricsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 75);

/**
 * @generated from message chalk.server.v1.QueryRawMetricsResponse
 */
export type QueryRawMetricsResponse = Message<"chalk.server.v1.QueryRawMetricsResponse"> & {
  /**
   * VictoriaMetrics' matrix result verbatim: samples are neither snapped to a
   * bucket grid nor gap-filled, unlike GetChartSnapshot.
   *
   * @generated from field: repeated chalk.server.v1.RawMetricsQuerySeries series = 1;
   */
  series: RawMetricsQuerySeries[];
};

/**
 * Describes the message chalk.server.v1.QueryRawMetricsResponse.
 * Use `create(QueryRawMetricsResponseSchema)` to create a new message.
 */
export const QueryRawMetricsResponseSchema: GenMessage<QueryRawMetricsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_chart, 76);

/**
 * @generated from enum chalk.server.v1.SelectedOutput
 */
export enum SelectedOutput {
  /**
   * @generated from enum value: SELECTED_OUTPUT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SELECTED_OUTPUT_SERIES = 1;
   */
  SERIES = 1,

  /**
   * @generated from enum value: SELECTED_OUTPUT_FORMULA = 2;
   */
  FORMULA = 2,
}

/**
 * Describes the enum chalk.server.v1.SelectedOutput.
 */
export const SelectedOutputSchema: GenEnum<SelectedOutput> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_chart, 0);

/**
 * ChartMetricsBackend selects which metrics store answers a chart snapshot.
 * UNSPECIFIED falls back to the environment's configured default (Timescale).
 *
 * @generated from enum chalk.server.v1.ChartMetricsBackend
 */
export enum ChartMetricsBackend {
  /**
   * @generated from enum value: CHART_METRICS_BACKEND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CHART_METRICS_BACKEND_TIMESCALE = 1;
   */
  TIMESCALE = 1,

  /**
   * @generated from enum value: CHART_METRICS_BACKEND_VICTORIA_METRICS = 2;
   */
  VICTORIA_METRICS = 2,

  /**
   * Like VICTORIA_METRICS, but a chart VictoriaMetrics cannot represent returns
   * an error instead of silently falling back to TimescaleDB. For QA/debugging
   * of VictoriaMetrics chart coverage.
   *
   * @generated from enum value: CHART_METRICS_BACKEND_VICTORIA_METRICS_STRICT = 3;
   */
  VICTORIA_METRICS_STRICT = 3,
}

/**
 * Describes the enum chalk.server.v1.ChartMetricsBackend.
 */
export const ChartMetricsBackendSchema: GenEnum<ChartMetricsBackend> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_chart, 1);

/**
 * Display grouping for MetricKind values, used to organize the metric-kind chart option
 * dropdown into sections. This is a server-side display concern (not a code artifact emitted
 * by the chalkpy SDK), so it lives in the server package rather than chalk.artifacts.v1.
 *
 * @generated from enum chalk.server.v1.MetricKindGroup
 */
export enum MetricKindGroup {
  /**
   * @generated from enum value: METRIC_KIND_GROUP_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: METRIC_KIND_GROUP_FEATURES = 1;
   */
  FEATURES = 1,

  /**
   * @generated from enum value: METRIC_KIND_GROUP_RESOLVERS = 2;
   */
  RESOLVERS = 2,

  /**
   * @generated from enum value: METRIC_KIND_GROUP_QUERIES = 3;
   */
  QUERIES = 3,

  /**
   * @generated from enum value: METRIC_KIND_GROUP_STREAMING = 4;
   */
  STREAMING = 4,

  /**
   * @generated from enum value: METRIC_KIND_GROUP_CRONS = 5;
   */
  CRONS = 5,

  /**
   * @generated from enum value: METRIC_KIND_GROUP_ONLINE_STORE = 6;
   */
  ONLINE_STORE = 6,

  /**
   * @generated from enum value: METRIC_KIND_GROUP_GPU = 7;
   */
  GPU = 7,

  /**
   * @generated from enum value: METRIC_KIND_GROUP_BILLING = 8;
   */
  BILLING = 8,

  /**
   * @generated from enum value: METRIC_KIND_GROUP_INFRASTRUCTURE = 9;
   */
  INFRASTRUCTURE = 9,
}

/**
 * Describes the enum chalk.server.v1.MetricKindGroup.
 */
export const MetricKindGroupSchema: GenEnum<MetricKindGroup> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_chart, 2);

/**
 * @generated from enum chalk.server.v1.MetricFormulaOperandKind
 */
export enum MetricFormulaOperandKind {
  /**
   * @generated from enum value: METRIC_FORMULA_OPERAND_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: METRIC_FORMULA_OPERAND_KIND_SERIES = 1;
   */
  SERIES = 1,

  /**
   * @generated from enum value: METRIC_FORMULA_OPERAND_KIND_DATASET = 2;
   */
  DATASET = 2,

  /**
   * @generated from enum value: METRIC_FORMULA_OPERAND_KIND_FEATURE = 3;
   */
  FEATURE = 3,
}

/**
 * Describes the enum chalk.server.v1.MetricFormulaOperandKind.
 */
export const MetricFormulaOperandKindSchema: GenEnum<MetricFormulaOperandKind> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_chart, 3);

/**
 * @generated from enum chalk.server.v1.MetricHealthStatus
 */
export enum MetricHealthStatus {
  /**
   * @generated from enum value: METRIC_HEALTH_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: METRIC_HEALTH_STATUS_HEALTHY = 1;
   */
  HEALTHY = 1,

  /**
   * @generated from enum value: METRIC_HEALTH_STATUS_UNHEALTHY = 2;
   */
  UNHEALTHY = 2,

  /**
   * @generated from enum value: METRIC_HEALTH_STATUS_NO_CHECKS = 3;
   */
  NO_CHECKS = 3,
}

/**
 * Describes the enum chalk.server.v1.MetricHealthStatus.
 */
export const MetricHealthStatusSchema: GenEnum<MetricHealthStatus> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_chart, 4);

/**
 * @generated from service chalk.server.v1.ChartsService
 */
export const ChartsService: GenService<{
  /**
   * The three introspection RPCs below expose the raw VictoriaMetrics series
   * behind an environment's charts. VM series names and labels are an internal
   * implementation detail rather than a stable customer-facing surface, but the
   * surface is useful enough to hand to a customer on request, so it carries
   * MONITORING_READ and the handlers scope every lookup to the caller's own
   * environment. Unscoped access — the whole instance, including cluster-scoped
   * series that carry no environment_id — needs either a self-hosted metadata plane
   * or PERMISSION_CHALK_ADMIN (granted implicitly to @chalk.ai agents). On Chalk's
   * shared plane one telemetry deployment serves many customers, so that scoping is
   * the tenant boundary, not a convenience.
   *
   * @generated from rpc chalk.server.v1.ChartsService.ListRawMetrics
   */
  listRawMetrics: {
    methodKind: "unary";
    input: typeof ListRawMetricsRequestSchema;
    output: typeof ListRawMetricsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ChartsService.GetRawMetricLabelNames
   */
  getRawMetricLabelNames: {
    methodKind: "unary";
    input: typeof GetRawMetricLabelNamesRequestSchema;
    output: typeof GetRawMetricLabelNamesResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ChartsService.GetRawMetricLabelValues
   */
  getRawMetricLabelValues: {
    methodKind: "unary";
    input: typeof GetRawMetricLabelValuesRequestSchema;
    output: typeof GetRawMetricLabelValuesResponseSchema;
  },
  /**
   * QueryRawMetrics evaluates caller-authored MetricsQL, which Chalk cannot rewrite to
   * carry an environment scope. It therefore needs unscoped raw access, which the
   * handler grants on a self-hosted metadata plane (the VictoriaMetrics instance holds
   * only that customer's data) or to PERMISSION_CHALK_ADMIN. The annotation is
   * MONITORING_READ because on a self-hosted plane that is genuinely the bar; a caller
   * who does not clear the handler's check gets PermissionDenied.
   *
   * @generated from rpc chalk.server.v1.ChartsService.QueryRawMetrics
   */
  queryRawMetrics: {
    methodKind: "unary";
    input: typeof QueryRawMetricsRequestSchema;
    output: typeof QueryRawMetricsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ChartsService.ListCharts
   */
  listCharts: {
    methodKind: "unary";
    input: typeof ListChartsRequestSchema;
    output: typeof ListChartsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ChartsService.ListChartAnnotations
   */
  listChartAnnotations: {
    methodKind: "unary";
    input: typeof ListChartAnnotationsRequestSchema;
    output: typeof ListChartAnnotationsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ChartsService.CreateChartAnnotation
   */
  createChartAnnotation: {
    methodKind: "unary";
    input: typeof CreateChartAnnotationRequestSchema;
    output: typeof CreateChartAnnotationResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ChartsService.DeleteChartAnnotation
   */
  deleteChartAnnotation: {
    methodKind: "unary";
    input: typeof DeleteChartAnnotationRequestSchema;
    output: typeof DeleteChartAnnotationResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ChartsService.GetChartSnapshot
   */
  getChartSnapshot: {
    methodKind: "unary";
    input: typeof GetChartSnapshotRequestSchema;
    output: typeof GetChartSnapshotResponseSchema;
  },
  /**
   * Evaluates an allowlisted VictoriaMetrics chart for a cluster owned by the
   * requesting team. The server resolves both the cluster scope and VM client.
   *
   * @generated from rpc chalk.server.v1.ChartsService.GetClusterChartSnapshot
   */
  getClusterChartSnapshot: {
    methodKind: "unary";
    input: typeof GetClusterChartSnapshotRequestSchema;
    output: typeof GetClusterChartSnapshotResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ChartsService.GetChartSnapshotByQuery
   */
  getChartSnapshotByQuery: {
    methodKind: "unary";
    input: typeof GetChartSnapshotByQueryRequestSchema;
    output: typeof GetChartSnapshotByQueryResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ChartsService.UpdateMetricConfig
   */
  updateMetricConfig: {
    methodKind: "unary";
    input: typeof UpdateMetricConfigRequestSchema;
    output: typeof UpdateMetricConfigResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ChartsService.DecompileMetricConfig
   */
  decompileMetricConfig: {
    methodKind: "unary";
    input: typeof DecompileMetricConfigRequestSchema;
    output: typeof DecompileMetricConfigResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ChartsService.CreateChart
   */
  createChart: {
    methodKind: "unary";
    input: typeof CreateChartRequestSchema;
    output: typeof CreateChartResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ChartsService.DeleteChart
   */
  deleteChart: {
    methodKind: "unary";
    input: typeof DeleteChartRequestSchema;
    output: typeof DeleteChartResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ChartsService.GetChart
   */
  getChart: {
    methodKind: "unary";
    input: typeof GetChartRequestSchema;
    output: typeof GetChartResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ChartsService.GetChartOptions
   */
  getChartOptions: {
    methodKind: "unary";
    input: typeof GetChartOptionsRequestSchema;
    output: typeof GetChartOptionsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ChartsService.GetFeatureMetrics
   */
  getFeatureMetrics: {
    methodKind: "unary";
    input: typeof GetFeatureMetricsRequestSchema;
    output: typeof GetFeatureMetricsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ChartsService.GetResolverMetrics
   */
  getResolverMetrics: {
    methodKind: "unary";
    input: typeof GetResolverMetricsRequestSchema;
    output: typeof GetResolverMetricsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ChartsService.GetQueryMetrics
   */
  getQueryMetrics: {
    methodKind: "unary";
    input: typeof GetQueryMetricsRequestSchema;
    output: typeof GetQueryMetricsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ChartsService.GetMetricOptions
   */
  getMetricOptions: {
    methodKind: "unary";
    input: typeof GetMetricOptionsRequestSchema;
    output: typeof GetMetricOptionsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ChartsService.GetFormulaOptions
   */
  getFormulaOptions: {
    methodKind: "unary";
    input: typeof GetFormulaOptionsRequestSchema;
    output: typeof GetFormulaOptionsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.ChartsService.ListChartsWithCronAlerts
   */
  listChartsWithCronAlerts: {
    methodKind: "unary";
    input: typeof ListChartsWithCronAlertsRequestSchema;
    output: typeof ListChartsWithCronAlertsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_chalk_server_v1_chart, 0);

